<template>
  <ag-select
    :id="id"
    :value="value"
    :options="recipes"
    @change="$emit('change', $event)"
    placeholder="Select a recipe"
  />
</template>

<script>
  export default {
    name: "RecipeSelect",
    props: {
      id: String,
      value: [String, Number]
    },
    data: () => ({
      recipes: []
    }),
    async mounted() {
      try {
        const recipes = await this.$service.recipe.findAll();

        this.recipes = recipes.map(recipe => {
          return {
            id: recipe.id,
            label: recipe.name
          }
        })
        
      } catch (e) {
        console.error(`Error loading recipes`, e);
      }
    },
  };
</script>

<style scoped lang="scss"></style>
